import { render, staticRenderFns } from "./BestAthletesEventAttendeeList.vue?vue&type=template&id=b51af3ea&"
import script from "./BestAthletesEventAttendeeList.vue?vue&type=script&lang=ts&"
export * from "./BestAthletesEventAttendeeList.vue?vue&type=script&lang=ts&"
import style0 from "./BestAthletesEventAttendeeList.vue?vue&type=style&index=0&id=b51af3ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports